'use client';

import ProductAndCategory from '@/joystagram-components/components/consumer/product-and-category';

export default function ProductAndCategoryClient({
  productOptionsPromise,
  category,
  slug,
}) {
  return (
    <ProductAndCategory
      productOptionsPromise={productOptionsPromise}
      category={category}
      slug={slug}
    />
  );
}
